import React from "react";

import { t } from "i18next";
import { Trans } from "react-i18next";
import ValidationError from "../Shared/ValidationError";
import {
    MAX_LABELS_PER_CLASSIFIER,
    MIN_LABELS_PER_CLASSIFIER,
} from "../../utils/constants";

const ClassifierLabelsCard = ({
    labels,
    setLabels,
    error,
    isFormSubmitted,
}) => {
    const handleChange = (event, index) => {
        const newLabels = [...labels];
        newLabels[index][event.target.name] = event.target.value;
        setLabels(newLabels);
    };

    const removeLabelValue = (index) => {
        const newLabels = [...labels];
        newLabels.splice(index, 1);
        setLabels(newLabels);
    };

    const getValue = (index = labels?.length - 1 || 0) => {
        if (labels?.length) {
            return +labels[index].value + 1;
        }
        return 1;
    };

    const isCardsClosable = () => labels.length > MIN_LABELS_PER_CLASSIFIER;

    const isCardsAddable = () => labels.length < MAX_LABELS_PER_CLASSIFIER;

    const getNewLabelValue = () => ({ label: "", value: getValue() });

    const addLabelValue = () => {
        setLabels((prevLabels) => [...prevLabels, getNewLabelValue()]);
    };

    const renderLabelValueCard = () => {
        return labels?.map((label, index) => {
            return (
                <div className="item-list mb-2" key={index}>
                    <div className="flex justify-between align-center">
                        <div className="input-group w-full">
                            <div className="tags px-2 py-2 whitespace-wrap">
                                <h4 className="uppercase text-xs required">
                                    <Trans i18nKey="label">Label</Trans>
                                </h4>
                                <input
                                    className="input-element small-input"
                                    name="label"
                                    value={label?.label ?? ""}
                                    type="text"
                                    placeholder={t("label")}
                                    onChange={(e) => handleChange(e, index)}
                                />
                                <ValidationError
                                    errorMessage={
                                        isFormSubmitted &&
                                        error[`${index}.label`]
                                    }
                                />
                            </div>
                        </div>
                        <div className="input-group w-full">
                            <div className="tags px-2 py-2 whitespace-wrap">
                                <h4 className="uppercase text-xs required">
                                    <Trans i18nKey="value">Value</Trans>
                                </h4>
                                <input
                                    className="input-element small-input"
                                    name="value"
                                    value={label?.value ?? ""}
                                    type="number"
                                    placeholder={t("value")}
                                    onChange={(e) => handleChange(e, index)}
                                />
                                <ValidationError
                                    errorMessage={
                                        isFormSubmitted &&
                                        error[`${index}.value`]
                                    }
                                />
                            </div>
                        </div>
                        {isCardsClosable() && (
                            <div className="icon-wrapper text-xs mt-1">
                                <i
                                    className="fas fa-times cursor-pointer"
                                    onClick={() => removeLabelValue(index)}
                                />
                            </div>
                        )}
                    </div>
                </div>
            );
        });
    };

    return (
        <>
            <div className="input-group flex flex-col">
                {renderLabelValueCard()}
                {isCardsAddable() && (
                    <div className="self-end p-2">
                        <span
                            onClick={addLabelValue}
                            className="hyper-btn text-xs"
                        >
                            <i className="fas fa-plus fa-xs mr-1"></i>
                            {t("addTitle", { entity: "label" })}
                        </span>
                    </div>
                )}
            </div>
        </>
    );
};

export default ClassifierLabelsCard;
